import { computedFn } from 'mobx-utils';
import { runtime, Runtime } from '../../Runtime';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { TimeSwitch } from './TimeSwitch';

export class RuntimeTimeSwitch {
  readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  @memoize
  get forTime() {
    return computedFn(
      (pastTime: number, updateInterval: number = 250): TimeSwitch =>
        new TimeSwitch(runtime.runtimeClock.getCustomClock(updateInterval), pastTime)
    );
  }
}
